export enum ImplantCustomKey {
  brandBaseDataValueId = 'brand_attribute_base_data_value_id',
  systemBaseDataValueId = 'system_attribute_base_data_value_id',
  platformBaseDataValueId = 'platform_attribute_base_data_value_id',
  groupBaseDataValueId = 'group_attribute_base_data_value_id',
  implantBrand = 'implant_brand',
}
